module.exports = __webpack_public_path__ + "img/jyb-mHeader.2fa3fd5a.png";